var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-about"},[_c('SRF',[_c('Core')],1),_c('SRF',[_c('CompanyInfo')],1),_c('SRF',[_c('Banner',{ref:"bannerRef",attrs:{"bannerShow":_vm.bannerShow}})],1),_c('SRF',[_c('Honor',{attrs:{"list":_vm.topList}})],1),_c('SRF',[_c('HonorSwiper',{attrs:{"list":_vm.bottomList}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }